export default __webpack_public_path__ + "assets/images/40df2bc4b182af5a1af906124ad451c5.jpeg";